/* Change link colour on hover */
const hex = ["#00ff00", "#fff700", "#ff0000", "#00e5ff", "#8c00ff"];
let hexNum = 0;

function colorLinks(hex) {
  const links = Array.from(document.querySelectorAll("a, .collapsible-trigger"));
  let oldColor;
  links.forEach(link => {
    
    // Add new color on hover
    link.addEventListener('mouseenter', () => {
      oldColor = link.style.color;
      link.style.color = hex[hexNum];
      if (hexNum < 4){
        hexNum ++; 
      } else {
        hexNum = 0;
      }
    })
    
    // Reset to old color on mouse leave
    link.addEventListener('mouseleave', () => {
      link.style.color = oldColor; 
    })

  })
}

setTimeout(() => {
  colorLinks(hex);
}, "1000")

